import React, { useState } from 'react';
import ReusableTextField from '../../components/common/ReusableTextField';
import PrimaryButton from '../../components/common/PrimaryButton';
import SecondaryButton from '../../components/common/SecondaryButton';

const Support = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    whatsapp: '',
    email: '',
    details: ''
  });

  const updateField = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const handleCancel = () => {
    setForm({ firstName: '', lastName: '', whatsapp: '', email: '', details: '' });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Integrate with backend or email service
    console.log('Support form submitted', form);
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="mb-4">
            <h3 className="fw-bold">Support</h3>
            <p className="text-muted mb-0">Got some queries or have suggestions? Write to us</p>
          </div>

          <div className="card shadow-sm">
            <div className="card-body p-4 p-md-5">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <ReusableTextField
                      name="firstName"
                      label="First Name"
                      required
                      placeholder="Enter your first name"
                      value={form.firstName}
                      onChange={updateField('firstName')}
                    />
                  </div>
                  <div className="col-md-6">
                    <ReusableTextField
                      name="lastName"
                      label="Last Name"
                      required
                      placeholder="Enter your last name"
                      value={form.lastName}
                      onChange={updateField('lastName')}
                    />
                  </div>
                  <div className="col-md-6">
                    <ReusableTextField
                      name="whatsapp"
                      label="WhatsApp Number"
                      required
                      placeholder="Enter your WhatsApp number"
                      value={form.whatsapp}
                      onChange={updateField('whatsapp')}
                    />
                  </div>
                  <div className="col-md-6">
                    <ReusableTextField
                      name="email"
                      type="email"
                      label="Email Address"
                      placeholder="Enter your email address"
                      value={form.email}
                      onChange={updateField('email')}
                    />
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Business Details / How Nurturix Can Help</label>
                      <textarea
                        className="form-control"
                        rows={5}
                        placeholder="A little detail about yourself and/or your company and which product of ours can help you to grow and give a piece of mind."
                        value={form.details}
                        onChange={updateField('details')}
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2 mt-2">
                  <SecondaryButton type="button" onClick={handleCancel}>Cancel</SecondaryButton>
                  <PrimaryButton type="submit">Send</PrimaryButton>
                </div>
              </form>
            </div>
          </div>

          <div className="row mt-5 g-4">
            <div className="col-md-6">
              <div className="d-flex align-items-center gap-3">
                <span className="contact-circle"><i className="bi bi-envelope fs-4 text-secondary"></i></span>
                <div>
                  <div className="fw-semibold">Email:</div>
                  <a href="mailto:support@prospectpulse.in" className="text-decoration-none">support@prospectpulse.in</a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex align-items-center gap-3">
                <span className="contact-circle"><i className="bi bi-telephone fs-4 text-secondary"></i></span>
                <div>
                  <div className="fw-semibold">Call:</div>
                  <a href="tel:+919354200796" className="text-decoration-none">+91 9354200796</a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <div className="fw-semibold">Our Offices:</div>
            <div className="text-muted">B-16, Koyla Vihar, Seepat Road, Near RTO Office, Bilaspur, Chhattisgarh-495006</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support; 